import { createContext, useContext } from 'react';

/**
 * Context for WebSocket synchronization
 * This context is intentionally minimal - the Provider handles sync logic internally.
 * Can be extended in the future to expose sync controls or status if needed.
 */
export type WebSocketSyncContextValue = {};

export const WebSocketSyncContext = createContext<
  WebSocketSyncContextValue | undefined
>(undefined);

/**
 * Hook to access WebSocketSync context
 * Currently minimal, but ready for future extensions
 */
export function useWebSocketSync(): WebSocketSyncContextValue {
  const context = useContext(WebSocketSyncContext);

  if (!context) {
    throw new Error(
      'useWebSocketSync must be used within a WebSocketSyncProvider',
    );
  }

  return context;
}
